import {
  ActionIcon,
  Button,
  Checkbox,
  Flex,
  Menu,
  Table,
  Text,
  TextInput,
  Title,
} from '@mantine/core'
import classes from './AdminSettings.module.css'
import { IconDots, IconSearch } from '@tabler/icons-react'

const MOCK_DATA = Array(30).fill({
  label: 'Custom field # label',
})

export const PermissionSetsCustomFields = () => {
  const rows = MOCK_DATA.map((item) => (
    <Table.Tr key={item.label}>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.label}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Checkbox />
      </Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Checkbox />
      </Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Menu>
          <Menu.Target>
            <ActionIcon variant="default" radius="xl" aria-label="Options">
              <IconDots style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item color="dark">Toggle edit access</Menu.Item>
            <Menu.Item color="red" onClick={() => {}}>
              Remove
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Table.Td>
    </Table.Tr>
  ))

  return (
    <>
      <Title order={4} p="md">
        Edit Permission Set
      </Title>
      <Flex justify="space-between" p="xs">
        <TextInput
          w={300}
          leftSection={<IconSearch size={18} />}
          leftSectionPointerEvents="none"
          size="sm"
          placeholder="Search"
        />
        <Button>Make Field Visible</Button>
      </Flex>
      <Table withRowBorders={false} verticalSpacing="xs">
        <Table.Thead>
          <Table.Tr className={classes.AdminSettings__thead}>
            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Field label
              </Text>
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Checkbox
                label={
                  <Text size="xs" mt={3}>
                    Read access
                  </Text>
                }
              />
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Checkbox
                label={
                  <Text size="xs" mt={3}>
                    Edit access
                  </Text>
                }
              />
            </Table.Th>

            <Table.Th>
              <Text size="xs">12 results</Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </>
  )
}
